export default "__VITE_PUBLIC_ASSET__8e9f2ed3__"